module.exports = __webpack_public_path__ + "static/media/garden.72348b0f.jpg";